import React from 'react';
import './Video.css'
import "bootstrap/dist/css/bootstrap.min.css";

const Video = ({image ,href}) => {
    return (
        <div className="col-lg-12 video-box section-title" data-aos="fade-right" data-aos-delay="100">
            <img src={image} className="img-fluid" alt="" />
            <a href={href} className="glightbox play-btn mb-4" data-vbtype="video" data-autoplay="true"></a>
        </div>
    )
}

export default Video
